import React, {PropTypes} from 'react';
import EventCalendar from 'react-event-calendar';
import moment from 'moment';
import SquadModal from './SquadModal.jsx';

const Squads = ({
  modalTitle,
  entries,
  month,
  year,
  modalVisible,
  onPreviousClick,
  onNextClick,
  onDayClick,
  onModalCloseClick,
  onEventClick
}) => {
  const monthForCalendar = month - 1, // EventCalendar plugin expects months starting from zero
        monthName = moment(new Date(`${year}/${month}/1`)).format('MMMM'); // Use moment to get the name of the month

  return (
    <div className="animated fadeIn">
      <div className="panel panel-default">
        <div className="panel-heading flex space-between">
          <h2 className="panel-title">{`${monthName}, ${year}`}</h2>
          <div>
            <button
              className="btn btn-link"
              onClick={onPreviousClick}
            >{`Previous`}</button>
            {` `}
            <button
              className="btn btn-link"
              onClick={onNextClick}
            >{`Next`}</button>
          </div>
        </div>
        <EventCalendar
          month={monthForCalendar}
          year={year}
          events={entries}
          maxEventSlots={30}
          onDayClick={onDayClick}
          onEventClick={onEventClick}
        />
      </div>
      <SquadModal
        title={modalTitle}
        visible={modalVisible}
        onCloseClick={onModalCloseClick}
      />
    </div>
  );
};

Squads.propTypes = {
  modalTitle: PropTypes.string,
  entries: PropTypes.arrayOf(PropTypes.object).isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  modalVisible: PropTypes.bool,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onDayClick: PropTypes.func,
  onModalCloseClick: PropTypes.func,
  onEventClick: PropTypes.func
};

export default Squads;



// WEBPACK FOOTER //
// ./src/features/tournament/squads/Squads.jsx